<template>
  <div>
    <el-form
      label-position="top"
      :model="registerRequest"
      @submit.prevent.native="register"
    >
      <!--                <div class="form-group{{ $errors->has('name') ? ' has-error' : '' }}">-->
      <b-alert show v-if="successMessage" variant="success">
        {{ successMessage }}
      </b-alert>
      <el-form-item
        label="用户名"
        autofocus
        prop="name"
        :rules="[{ required: true, message: '必填' }]"
      >
        <el-input v-model="registerRequest.name" :required="true"></el-input>
        <b-alert show v-if="errors && errors.name" variant="danger">
          <span v-for="(error, index) in errors.name" v-bind:key="index">
            {{ error }}
          </span>
        </b-alert>
      </el-form-item>
      <el-form-item
        label="邮箱地址"
        prop="email"
        :rules="[{ required: true, message: '必填' }]"
      >
        <el-input v-model="registerRequest.email" :required="true"></el-input>
        <el-form-item>
          <el-checkbox v-model="registerRequest.public_email"
            >邮箱公开显示
          </el-checkbox>
        </el-form-item>
        <div>
          <b-alert show v-if="errors && errors.email" variant="danger">
            <span v-for="(error, index) in errors.email" v-bind:key="index">
              {{ error }}
            </span>
          </b-alert>
          <b-alert show v-if="errors && errors.public_email" variant="danger">
            <span
              v-for="(error, index) in errors.public_email"
              v-bind:key="index"
            >
              {{ error }}
            </span>
          </b-alert>
        </div>
      </el-form-item>
      <el-form-item label="性 别" prop="gender">
        <el-select v-model="registerRequest.gender" placeholder="性 别">
          <el-option key="secret" label="保密" value="secret"></el-option>
          <el-option key="female" label="女" value="female"></el-option>
          <el-option key="male" label="男" value="male"></el-option>
        </el-select>
        <b-alert show v-if="errors && errors.gender" variant="danger">
          <span v-for="(error, index) in errors.gender" v-bind:key="index">
            {{ error }}
          </span>
        </b-alert>
      </el-form-item>
      <el-form-item
        label="密 码"
        prop="password"
        :rules="[{ required: true, message: '必填' }]"
      >
        <el-input
          type="password"
          v-model="registerRequest.password"
          autocomplete="off"
        ></el-input>
        <b-alert show v-if="errors && errors.password" variant="danger">
          <span v-for="(error, index) in errors.password" v-bind:key="index">
            {{ error }}
          </span>
        </b-alert>
      </el-form-item>
      <el-form-item
        label="确认密码"
        prop="password_confirmation"
        :rules="[{ required: true, message: '必填' }]"
      >
        <el-input
          type="password"
          v-model="registerRequest.password_confirmation"
          @keyup.enter.native="register"
          autocomplete="off"
        ></el-input>
        <b-alert
          show
          v-if="errors && errors.password_confirmation"
          variant="danger"
        >
          <span
            v-for="(error, index) in errors.password_confirmation"
            v-bind:key="index"
          >
            {{ error }}
          </span>
        </b-alert>
      </el-form-item>
      <!--captcha-->
      <b-alert show v-if="successMessage" variant="success">
        {{ successMessage }}
      </b-alert>
      <el-form-item>
        <el-button @click="register" class="float-right">注册</el-button>
      </el-form-item>
      <b-alert show v-if="errors" variant="danger">
        <span
          v-for="(eachError, errorIndex) in errors"
          v-bind:key="errorIndex + '-error'"
        >
          <span v-for="(error, index) in eachError" v-bind:key="index">
            {{ error }}
          </span>
        </span>
      </b-alert>
    </el-form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "Register.vue",
  data() {
    return {
      registerRequest: {
        name: "",
        email: "",
        gender: "secret",
        public_email: true,
        password: "",
        password_confirmation: ""
      },
      errors: "",
      successMessage: ""
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    register: function() {
      this.setLoading(true);
      this.successMessage = "";
      this.errors = "";
      this.$store
        .dispatch("register", this.registerRequest)
        .then(res => {
          this.setLoading(false);
          if (res.status == 201) {
            this.successMessage = res.data.message;
            this.$emit("success");
          }
        })
        .catch(err => {
          this.setLoading(false);
          this.errors = err.response.data.errors;
        });
    }
  }
};
</script>

<style scoped></style>
